import { render } from "./GalleryCarousel.vue?vue&type=template&id=3c44ff02&scoped=true"
import script from "./GalleryCarousel.vue?vue&type=script&lang=js"
export * from "./GalleryCarousel.vue?vue&type=script&lang=js"

import "./GalleryCarousel.vue?vue&type=style&index=0&id=3c44ff02&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c44ff02"]])

export default __exports__